import {Backbone} from 'Vertebrae';
import {AffinityGroup} from '../model/affinityGroup';

export const AffinityGroups = Backbone.Collection.extend({
    _name: 'AffinityGroups',
    model: AffinityGroup,
    url: '/registration/groups/get.json',
});
